import React, { Suspense, useEffect, useState } from "react";
import { ConfigProvider, Layout, Spin } from "antd";
import { LocalStorageKeys } from "../constants/localStorageKeys";
import * as localStorageService from "./../service/localStorageService";
import { useStore } from "./../store/store";
import './auth-layout.scss'
import { CommonConstants } from "../constants/commonConstants";
import { antdThemeFor } from "../constants/brand";
import { useResolvedThemeMode } from "./theme-mode/theme-mode";
import { ErrorBoundary } from "./error-boundary/error-boundary";
import { Outlet } from "react-router-dom";
import { Content } from "antd/es/layout/layout";

export const PublicLayout=()=>{
    const themeMode = useResolvedThemeMode();

    return <div>
    <Layout className="public-layout-wrapper">
            <ConfigProvider
              theme={antdThemeFor(themeMode)}
              direction={
                localStorageService.getValue(LocalStorageKeys.Lang) == CommonConstants.ArabicLanguageCode
                  ? "rtl"
                  : "ltr"
              }
            ></ConfigProvider>
            <ErrorBoundary>
            <Content className="content-body-wrapper">
                <Outlet />
            </Content>
            </ErrorBoundary>
            </Layout>
            </div>
}